<template>
  <header id="nav">
    <nav class="nav">
      <div class="subdomain_nav_wrapper">
        <div class="nav_container">
          <ul class="subdomain_nav_contents">
            <div/>
            <div class="link_contents">
              <li
                v-for="subdomainLink in subdomainList"
              >
                <app-link v-bind:link="subdomainLink" v-bind:homeUrl="homeUrl" class="subdomain_link"/>
              </li>
            </div>
          </ul>
        </div>
      </div>
      <div class="main_nav_wrapper">
        <div class="nav_container">
          <div class="main_nav_contents">
            <a
              href="https://opentrons.com/"
              data-gtm-category="p-header"
              data-gtm-label="logo"
              data-gtm-action="click"
            >
              <img
                class="nav_logo"
                src="https://s3.amazonaws.com/opentrons-images/website/ot_logo_full.png"
                alt="Opentrons Home"
              >
            </a>
            <button class='nav_button' v-on:click="handleBurgerClick">
              <img v-if="!mobileMenu" src="./../assets/img/nav-mobile.svg" alt="Mobile menu open">
              <img v-else src="./../assets/img/x-icon.svg" alt="Mobile menu close">
            </button>
            <ul
              class='nav_list'
              v-bind:class="{
                nav_list_open: mobileMenu,
                nav_list_submenu_open: !!activeName,
              }"
            >
              <li
                @click.self="handleItemClick(item.name)"
                v-for="item in navigationList"
                :key="item.name"
                v-bind:class="{
                  nav_url_active: item.name === activeName,
                  nav_url_parent: !!item.links
                }"
                class="nav_url"
              >
                <app-link v-if="item.url" v-bind:link="item" v-bind:homeUrl="homeUrl" class="nav_url_name"/>
                <span v-if="!item.url" class="nav_url_name"
                      @click.self="handleItemClick(item.name)">{{item.name}}</span>
                <div
                  class="dropdown_small"
                  v-if="item.links && item.name === activeName"
                  v-bind:class="{
                    dropdown_small_open: item.name === activeNameDelay,
                  }"
                >
                  <button class="nav_sub_name" @click="handleItemClick('')">
                    {{item.name}}
                  </button>
                  <ul
                    class="nav_sub"
                    v-bind:class="{
                      nav_sub_support: item.name === 'Support',
                    }"
                  >
                    <navigation-sub v-for="subitem in item.links" :key="subitem.name" v-bind:subitem="subitem"
                                    v-bind:homeUrl="homeUrl"/>
                  </ul>
                  <div v-if="item.text" v-html="item.text" class="nav_text"/>
                </div>
              </li>
              <a
                href="https://opentrons.com/contact"
                target="_blank" 
                rel="noopener noreferrer"
                class="nav_contact_button"
              >
                CONTACT SALES
              </a>
              <a 
                href="https://opentrons.com/demo"
                target="_blank"
                rel="noopener noreferrer"
                class="demo_button"
              >
                SCHEDULE DEMO
              </a>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
  import navData from './../data/nav.json'
  import NavigationSub from './NavigationSub'
  import AppLink from './AppLink'

  export default {
    name: 'Navigation',
    components: {
      AppLink,
      NavigationSub
    },
    data () {
      return {
        subdomainList: navData.subdomainList,
        navigationList: navData.navigationList,
        homeUrl: navData.homeUrl,
        activeName: '',
        activeNameDelay: '',
        mobileMenu: false
      }
    },
    created () {
      window.fetch('https://opentrons.com/api/navigationData.json')
        .then(response => {
          response.json().then(data => {
            if (data && data.homeUrl) {
              this.subdomainList = data.subdomainList
              this.navigationList = data.navigationList
              this.homeUrl = data.homeUrl
            }
          })
        })
        .catch(e => console.error(e))
    },
    methods: {
      handleItemClick (name) {
        if (name === this.activeName) {
          this.activeName = ''
          this.activeNameDelay = ''
        } else {
          this.activeName = name
          setTimeout(() => {
            this.activeNameDelay = name
          }, 100)
        }
      },
      handleBurgerClick () {
        if (this.mobileMenu === false) {
          document.body !== null && document.body.classList.add('no_scroll')
        } else {
          document.body !== null && document.body.classList.remove('no_scroll')
        }
        this.mobileMenu = !this.mobileMenu
      }
    }
  }
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// Navigation.vue?67e1559c